import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '~components/skeleton';
import './style.scss';
import '../event-item/style.scss';

function LoaderCard({ isMobile }) {
    return (
        <li className="event-item">
            {!isMobile && (
                <div className="event-item__userpic">
                    <Skeleton fontSize={112} />
                </div>
            )}
            <div className="event-item__wrap">
                <div className="event-item__inner">
                    <div className="event-item__event-inner">
                        <h6 className="event-item__header">
                            <Skeleton
                                fontSize={isMobile ? 13 : 15}
                                lineHeight={isMobile ? 20 : 19}
                                width={isMobile ? 270 : 300}
                            />
                        </h6>
                        <a>
                            <Skeleton fontSize={isMobile ? 13 : 15} lineHeight={isMobile ? 20 : 19} />
                        </a>
                    </div>
                    {!isMobile && (
                        <div className="event-item__icon">
                            <Skeleton fontSize={isMobile ? 13 : 24} lineHeight={isMobile ? 20 : 24} />
                        </div>
                    )}
                    <div className="event-item__time">
                        <Skeleton
                            fontSize={isMobile ? 13 : 15}
                            lineHeight={isMobile ? 20 : 19}
                            width={isMobile ? 120 : 85}
                        />

                        {!isMobile && <Skeleton fontSize={15} lineHeight={isMobile ? 20 : 19} width={54} />}
                    </div>
                </div>
            </div>
        </li>
    );
}

LoaderCard.propTypes = {
    isMobile: PropTypes.bool.isRequired,
}


export default LoaderCard;
export { LoaderCard };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/events-list/loader-card/index.js